import React, { useEffect, useState } from 'react'
import { IFilterDataArray, IFilterOption } from './../../../interfaces/filterProps'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEllipsisH } from '@fortawesome/pro-solid-svg-icons/faEllipsisH'
import { faTimes } from '@fortawesome/pro-solid-svg-icons/faTimes'
import { faTrashAlt } from '@fortawesome/pro-solid-svg-icons/faTrashAlt'
import { getFixedFiltersData, getInputsData } from 'helpers/filter'
import styles from './index.module.scss'

interface IFilterAdvance {
  data: any[]
  translations: any
  columns: IFilterOption[]
  onClose: any
  onClear: any
  openFilters?: any
  fixed?: any[]
}

const FilterAdvance: React.FC<IFilterAdvance> = ({ data, translations, columns, onClose, onClear, openFilters, fixed = undefined }) => {
  const [filtersList, setFiltersList] = useState([] as any[])

  useEffect(() => {
    setFiltersList(data)
  }, [data])

  return (
    <div className={`${styles.container} rankmiTable-activeFilterViewer-filter-advance`}>
      <div className="d-flex align-center">
        <div className={`${styles.filterContainer} rankmiTable-activeFilterViewer-filter-advance-list`}>
          {fixed && (
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <div className={styles.title}>{translations.activeFilterViewer.simple.title}:</div>
              {fixed.map((data, index) => (
                <div className={styles.fixedFilter} key={`fixedFilter-simple-${index}`}>
                  {getFixedFiltersData(data, columns, translations)}
                </div>
              ))}
            </div>
          )}
          {filtersList.map(({ data: group, groupCondition }, index) => (
            <div className={`${styles.filterRow} rankmiTable-activeFilterViewer-filter-advance-row`} key={`activeFilter-advance-group-${index}`}>
              <div className={styles.groupTitle}> {`${translations.filterGroup} ${index + 1}: `}</div>
              <div className={styles.filters}>
                {group &&
                  (openFilters ? group.slice(0, 2) : group).map((row: IFilterDataArray, rowIndex: number) => (
                    <div className="d-flex align-center" key={`activeFilter-advance-group-${index}-row-${rowIndex}`}>
                      <div className={`${styles.filter} rankmiTable-activeFilterViewer-filter-advance-filter`}>
                        <div className={styles.filterName}>{getInputsData(row, columns, translations)}</div>
                        <FontAwesomeIcon className="ml-2" icon={faTimes} onClick={() => onClose(row.index)} />
                      </div>
                      {rowIndex !== (openFilters ? group.slice(0, 2) : group).length - 1 && (
                        <span className="mb-1" style={{ marginRight: 5 }}>
                          {translations.groupConditions[groupCondition]}
                        </span>
                      )}
                    </div>
                  ))}
                {openFilters && group.length > 2 && (
                  <div className={styles.customEllipsis} onClick={openFilters}>
                    <FontAwesomeIcon icon={faEllipsisH} />
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
      {data.length > 0 && (
        <div className={`${styles.clear} rankmiTable-activeFilterViewer-filter-advance-clear`} onClick={onClear}>
          {translations.activeFilterViewer.advance.clear}
          <FontAwesomeIcon className="ml-2" icon={faTrashAlt} />
        </div>
      )}
    </div>
  )
}

export default FilterAdvance
